import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./SearchField.scss";

const SearchField = props => {
	const { lang } = global;
	const {
		id,
		defaultValue,
		inputGroupClass,
		inputClass,
		iconClass,
		clearIconClass,
		placeholder,
		onChange,
		onSearch,
		clearable,
		dataTestId,
	} = props;
	const [value, setValue] = useState("");

	// When first mounted, update the local value if a `defaultValue` is provided
	useEffect(() => {
		if (defaultValue) setValue(defaultValue);
	}, []);

	const onClear = () => {
		setValue("");
		onSearch("");
		// construct an "event" for change handler methods with the most commonly read properties
		onChange({ target: { name: "search-field", value: "", type: "text" } });
	};

	return (
		<div className={classNames("search-group input-group", inputGroupClass)}>
			<input
				id={id}
				type="text"
				name="search-field"
				className={classNames("form-control", inputClass)}
				placeholder={placeholder}
				value={value}
				onChange={e => {
					onChange(e);
					setValue(e.target.value);
				}}
				onKeyPress={({ key }) => {
					if (key === "Enter") onSearch(value);
				}}
				data-test-id={dataTestId}
			/>
			<div className="input-group-btn">
				<If condition={clearable && value !== ""}>
					<button
						type="button"
						tabIndex="0"
						aria-label={lang.t("Clear")}
						className="clear-search btn btn-default"
						onClick={onClear}
					>
						<i className={clearIconClass} />
					</button>
				</If>
				<button
					type="button"
					className="btn btn-default"
					onClick={() => onSearch(value)}
					title={placeholder}
				>
					<i className={iconClass} />
				</button>
			</div>
		</div>
	);
};

SearchField.propTypes = {
	id: PropTypes.string,
	defaultValue: PropTypes.string,
	inputGroupClass: PropTypes.string,
	inputClass: PropTypes.string,
	iconClass: PropTypes.string,
	clearIconClass: PropTypes.string,
	placeholder: PropTypes.string,
	onChange: PropTypes.func,
	onSearch: PropTypes.func,
	clearable: PropTypes.bool,
	dataTestId: PropTypes.string,
};

SearchField.defaultProps = {
	id: undefined,
	defaultValue: "",
	inputGroupClass: "",
	inputClass: "",
	iconClass: "glyphicon glyphicon-search",
	clearIconClass: "glyphicon glyphicon-remove",
	placeholder: undefined,
	onChange: () => {},
	onSearch: () => {},
	clearable: false,
	dataTestId: undefined,
};

export default SearchField;
